const storageKey = (key: string) => `@GrpsPDV:${key}`;

export default storageKey;
